module.exports = __webpack_public_path__ + "img/icon_option.8b4ba55b.png";